// extracted by mini-css-extract-plugin
export default {"heru":"Heru_heru__PQc1o","imageCont":"Heru_imageCont__DF6DB"};